import styled from 'styled-components';
import COLORS from '../../../common/styles/color-pallete';
import DEVICES from '../../../common/styles/devices';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';

export const GotItButton = styled.button`
  margin-top: 32px;
  cursor: pointer;
  background-color: ${COLORS.dividerBlue};
  border-radius: 4px;
  border: 3px solid ${COLORS.dividerBlue};
  height: 46px;
  width: 335px;
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.bold};
  @media ${DEVICES.mobileXL} {
    min-width: unset;
    width: 100%;
  }
`;

export const FeeParentContainer = styled.div<{ $flexStart: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $flexStart }) => ($flexStart ? 'flex-start' : 'flex-end')};
  justify-content: center;
`;

export const FeesIncludedText = styled.div`
  align-items: flex-start;
  white-space: nowrap;
  color: ${COLORS.textLightGrey};
`;

export const FeesTitleText = styled.span<{ $isBold: boolean }>`
  text-align: end;
  font-size: 16px;
  line-height: 22px;
  font-family: ${({ $isBold }) => ($isBold ? FONT_FAMILY.hellix.bold : FONT_FAMILY.hellix.regular)};
  color: ${COLORS.textLightGrey};
`;

export const DiscountedFeeText = styled.span<{ $isBold: boolean }>`
  font-size: 16px;
  line-height: 22px;
  font-family: ${({ $isBold }) => ($isBold ? FONT_FAMILY.hellix.bold : FONT_FAMILY.hellix.regular)};
  color: ${COLORS.textLightGrey};
`;

export const FirstTimeTxnFeeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 0px;
`;
export const StrikedText = styled.span`
  text-decoration: line-through;
  margin: 0px 5px;
`;
export const FirstTxnFeePopUpCustomText = styled.div`
  margin-bottom: 5px;
`;

export const FXRateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${COLORS.textLightGrey};
`;
export const FxRatePopupContentContainer = styled.div`
  font-size: 14px;
`;

export const BoldCurrency = styled.span<{ $isBold: boolean }>`
  font-family: ${({ $isBold }) => ($isBold ? FONT_FAMILY.hellix.bold : FONT_FAMILY.hellix.regular)};
`;
